
    export const statelookupjson =[
    {
        "stateId": 1,
        "state": "ALABAMA"
    },
        {
            "stateId": 2,
            "state":"ALASKA"
        },
    // {
    //     "stateId": 55,
    //     "state": "AMERICAN SAMOA"
    // },
    {
        "stateId": 3,
        "state": "ARIZONA"
    },
    {
        "stateId": 4,
        "state": "ARKANSAS"
    },
    {
        "stateId": 5,
        "state": "CALIFORNIA"
    },
    {
        "stateId": 6,
        "state": "COLORADO"
    },
    {
        "stateId": 7,
        "state": "CONNECTICUT"
    },
    {
        "stateId": 8,
        "state": "DELAWARE"
    },
    {
        "stateId": 9,
        "state": "DISTRICT OF COLUMBIA"
    },
    // {
    //     "stateId": 56,
    //     "state": "FEDERATED STATES OF MICRONESIA"
    // },
    {
        "stateId": 10,
        "state": "FLORIDA"
    },
    {
        "stateId": 11,
        "state": "GEORGIA"
    },
    {
        "stateId": 12,
        "state": "GUAM"
    },
    {
        "stateId": 13,
        "state": "HAWAII"
    },
    {
        "stateId": 14,
        "state": "IDAHO"
    },
    {
        "stateId": 15,
        "state": "ILLINOIS"
    },
    {
        "stateId": 16,
        "state": "INDIANA"
    },
    {
        "stateId": 17,
        "state": "IOWA"
    },
    {
        "stateId": 18,
        "state": "KANSAS"
    },
    {
        "stateId": 19,
        "state": "KENTUCKY"
    },
    {
        "stateId": 20,
        "state": "LOUISIANA"
    },
    {
        "stateId": 21,
        "state": "MAINE"
    },
    // {
    //     "stateId": 57,
    //     "state": "MARSHALL ISLANDS"
    // },
    {
        "stateId": 22,
        "state": "MARYLAND"
    },
    {
        "stateId": 23,
        "state": "MASSACHUSETTS"
    },
    {
        "stateId": 24,
        "state": "MICHIGAN"
    },
    {
        "stateId": 25,
        "state": "MINNESOTA"
    },
    {
        "stateId": 26,
        "state": "MISSISSIPPI"
    },
    {
        "stateId": 27,
        "state": "MISSOURI"
    },
    {
        "stateId": 28,
        "state": "MONTANA"
    },
    {
        "stateId": 29,
        "state": "NEBRASKA"
    },
    {
        "stateId": 30,
        "state": "NEVADA"
    },
    {
        "stateId": 31,
        "state": "NEW HAMPSHIRE"
    },
    {
        "stateId": 32,
        "state": "NEW JERSEY"
    },
    {
        "stateId": 33,
        "state": "NEW MEXICO"
    },
    {
        "stateId": 34,
        "state": "NEW YORK"
    },
    {
        "stateId": 35,
        "state": "NORTH CAROLINA"
    },
    {
        "stateId": 36,
        "state": "NORTH DAKOTA"
    },
    {
        "stateId": 58,
        "state": "NORTHERN MARIANA ISLANDS"
    },
    {
        "stateId": 37,
        "state": "OHIO"
    },
    {
        "stateId": 38,
        "state": "OKLAHOMA"
    },
    {
        "stateId": 39,
        "state": "OREGON"
    },
    // {
    //     "stateId": 59,
    //     "state": "PALAU"
    // },
    {
        "stateId": 40,
        "state": "PENNSYLVANIA"
    },
    {
        "stateId": 41,
        "state": "PUERTO RICO"
    },
    {
        "stateId": 42,
        "state": "RHODE ISLAND"
    },
    {
        "stateId": 43,
        "state": "SOUTH CAROLINA"
    },
    {
        "stateId": 44,
        "state": "SOUTH DAKOTA"
    },
    {
        "stateId": 45,
        "state": "TENNESSEE"
    },
    {
        "stateId": 46,
        "state": "TEXAS"
    },
    {
        "stateId": 47,
        "state": "UTAH"
    },
    {
        "stateId": 48,
        "state": "VERMONT"
    },
    {
        "stateId": 49,
        "state": "VIRGIN ISLANDS"
    },
    {
        "stateId": 50,
        "state": "VIRGINIA"
    },
    {
        "stateId": 51,
        "state": "WASHINGTON"
    },
    {
        "stateId": 52,
        "state": "WEST VIRGINIA"
    },
    {
        "stateId": 53,
        "state": "WISCONSIN"
    },
    {
        "stateId": 54,
        "state": "WYOMING"
    }];
